import { useEffect, useState } from "react";

import { Auth, Hub } from "aws-amplify";

export function useAuthEventHandler({ onSignIn, onSignOut }) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);
  const [autoSignIn, setAutoSignIn] = useState(false);

  useEffect(() => {
    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signIn":
          setUser(data.payload.data);
          onSignIn();
          break;
        case "signOut":
          setUser(null);
          onSignOut();
          break;
        case "signUp":
          setAutoSignIn(true);
          break;
        default:
          break;
      }
    });

    return () => {
      Hub.remove("auth");
    };
  }, [onSignIn, onSignOut]);

  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        setLoading(true);
        const currentUser = await Auth.currentAuthenticatedUser();
        setUser(currentUser);
        onSignIn();
      } catch (error) {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    getCurrentUser();
  }, [onSignIn]);

  return { user, loading, autoSignIn };
}

export default useAuthEventHandler;
